import { pluralizeByCount } from "../../../../mp-utils/generic-utils"

export const formatMilliseconds = (milliseconds: number): string => {
  const seconds = Math.floor(milliseconds / 1000)
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  const minutesText = minutes
    ? `${minutes} ${pluralizeByCount("minute", minutes)}`
    : ""
  const secondsText = remainingSeconds
    ? `${remainingSeconds} ${pluralizeByCount("second", remainingSeconds)}`
    : ""

  return !!minutesText && !!secondsText
    ? `${minutesText} and ${secondsText}`
    : minutesText || secondsText || "0 seconds"
}
